import { colors } from '@flowwai-frontend/design-system'

const themes = {
   light: {
      actionPopoverBorder: 'border-gray-200',
      whiteBgColor: 'bg-base-white',
      actionItemText: 'text-gray-700',
      toastUtils: {
         refreshButtonRetryIconColor: colors['error-700']
      },
      whatsAppBgColor: 'bg-success-50',
      borderColor: 'border-gray-300',
      defaultHoverBgColor: 'hover:bg-gray-50',
      transparentBgColor: 'bg-[transparent]',
      skeletonLoaderBaseColor: colors['gray-300'],
      skeletonLoaderHighlightColor: '#EDF3F6',
      confirmationUI: {
         closeIconColor: colors['gray-500'],
         headingColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         xCloseHoverColor: 'hover:bg-gray-50'
      },
      deleteCard: {
         backgroundColor: 'bg-base-white',
         boardHeading: 'text-gray-900',
         description: 'text-gray-600',
         closeIconColor: colors['gray-500']
      },
      errorView: {
         bgColor: 'bg-gray-100',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600'
      }
   },
   dark: {}
}

export const commonTheme = themes.light
